import * as React from "react"
import T from "../T/T";
import { Link } from "gatsby";
import { LocaleLink } from "../../lib/IntlTools";
import "./styles.scss";

export default function NbcHero({ showReward, showTitle, customClassname, imgLink, text }) {

    return <div className={`design-slider ${customClassname}`}>
        <div className="slide">
            {!!showTitle && (
                <div className="concealed-text">
                    <div
                        className="concealed-text-container">
                        <h3><T>{text}</T></h3>
                    </div>
                    {!!showReward && (<div className="claim-rewards-button">
                        <Link to={LocaleLink("/form")}>
                            <T>claim-button</T>
                        </Link>
                    </div>
                    )}
                </div>
            )}
            <div className="image-bg">
                <img src={imgLink} alt="" />
            </div>
        </div>
    </div>
}
